import { render } from "./anc_tetanus_injections.vue?vue&type=template&id=0fd98388&scoped=true"
import script from "./anc_tetanus_injections.vue?vue&type=script&lang=js"
export * from "./anc_tetanus_injections.vue?vue&type=script&lang=js"

import "./anc_tetanus_injections.vue?vue&type=style&index=0&id=0fd98388&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd98388"]])

export default __exports__